import { apiRequest, apiPost } from '../utils/request';

// Calls the driver's phone makes while approving a truck console sign-in, plus the office's
// force-unpair. All authenticated as the person using them — the console itself never calls these.

/**
 * Detail for the confirm screen. Naming the truck there is what stops a driver approving the wrong
 * console, and makes a phishing attempt obvious.
 */
export function loadKioskPairing(userCode) {
    return function () {
        return apiRequest(`/api/kiosk/pairing/${encodeURIComponent(userCode)}`);
    };
}

/**
 * Approves the pairing: RunPlanner mints the console's token, claims the run, and pushes both to the
 * truck over the hub.
 *
 * Pass runId when the truck has more than one active run — a first approve without it comes back 409
 * with the candidates so the driver can choose.
 */
export function approveKioskPairing(userCode, runId = null) {
    return function () {
        return apiPost(`/api/kiosk/pairing/${encodeURIComponent(userCode)}/approve`, { runId });
    };
}

/** Explicit reject, for when a driver realises they've scanned the wrong truck. */
export function denyKioskPairing(userCode) {
    return function () {
        return apiPost(`/api/kiosk/pairing/${encodeURIComponent(userCode)}/deny`, {});
    };
}

/** Live console sessions, for the office's Manage Trucks view. */
export function loadKioskSessions(numberPlate = null) {
    return function () {
        const query = numberPlate ? `?numberPlate=${encodeURIComponent(numberPlate)}` : '';
        return apiRequest(`/api/kiosk/sessions${query}`);
    };
}

/** Signs a console out: the driver at the end of a shift, or the office force-unpairing. */
export function unpairKiosk(numberPlate) {
    return function () {
        return apiPost(`/api/kiosk/${encodeURIComponent(numberPlate)}/unpair`, {});
    };
}
